export default __webpack_public_path__ + "static/media/63.5645e7a8.png";